import React from 'react'

export interface Props {
  text?: string | null
}

const Newlines = ({text}: Props) => {
  if (!text) {
    return null
  }
  const parts = text.split('\n')
  return (
    <>
      {parts.map((line, index) => (
        <React.Fragment key={index}>
          {line}
          {index < parts.length - 1 && <br />}
        </React.Fragment>
      ))}
    </>
  )
}

export default Newlines
